<template>
      <div style="background:#f5f5f5">
          <sbspSalaryFilter :filterList.sync="filterList">
             <el-form-item label="工资月份：" style="margin-right:40px;">
            <div>
                  <el-select  v-model="filterList[0].value"   placeholder="请选择" style="width:90px;">
                    <el-option  v-for="item in filterList[0].options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                  </el-select>
                  <el-date-picker v-if="filterList[0].value=='qt'" v-model="filterList[0].value2"  style="width:230px;margin-left:4px;"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                  </el-date-picker>
              </div>
             </el-form-item>
          </sbspSalaryFilter>
          <div class="carBox">
              <card v-for="(cardData,i) in cardDatas" :key="i" :cardData='cardData' :labels='labels'>
                   <leftButton title="查看详情" @click="details()" style="top:15px;"></leftButton>
                   <leftButton title="导什么啊" @click="details()" style="top:42px;"></leftButton>
              </card>

          </div>
          <p class="more">
            <span>查看更多></span>

            </p>
      </div>

</template>

<script>
  import sbspSalaryFilter from "@/wage-components/sbs-salary-filter/sbsp-salary-filter.vue"
  import card from "@/views/demo/salary/template/card.vue"
   import leftButton from "@/views/demo/salary/template/left-button.vue"
  export default {
    name: "approval",
    components: {
      sbspSalaryFilter,
      card,
      leftButton
    },
    data() {
      return {
          labels:["账单人数","服务费合计","工资实发合计","非托收工资税金合计","通知单"],
        cardDatas:[
            {
            title:'202001付款通知单',
            keys:[,,'待确认'],
            info:{
                num1:100,
                num2:'2020-01',
                num3:1000,
                num4:'2020-02'
            },
            process:{
              processList:['HR1','HR2','HR3','HR4'],
              current:'HR2'
            },
            state:0    //0表示确认，1表示未提交，2表示当前已审批，3表示审批成功，4表示本人驳回，5表示其他人驳回
          },
            {
            title:'202001付款通知单',
            keys:[,,'待审批'],
            info:{
                num1:100,
                num2:'2020-01',
                num3:1000,
                num4:'2020-02'
            },
            process:{
              processList:['HR1','HR2','HR3','HR4'],
              current:'HR2'
            },
            state:1    //1表示未提交，2表示当前已审批，3表示审批成功，4表示本人驳回，5表示其他人驳回
          },
           {
            title:'202001付款通知单',
            keys:[,,'已确认'],
            info:{
                num1:100,
                num2:'2020-01',
                num3:1000,
                num4:'2020-02'
            },
            process:{
              processList:['HR1','HR2','HR3','HR4'],
              current:'HR2'
            },
            state:2    //1表示未提交，2表示当前已审批，3表示审批成功，4表示本人驳回，5表示其他人驳回
          },
            {
            title:'202001付款通知单',
            keys:[,,'待审批'],
            info:{
                num1:100,
                num2:'2020-01',
                num3:1000,
                num4:'2020-02'
            },
            process:{
              processList:['HR1','HR2','HR3','HR4'],
              current:'HR2'
            },
            state:3    //1表示未提交，2表示当前已审批，3表示审批成功，4表示本人驳回，5表示其他人驳回
          },
            {
            title:'202001付款通知单',
            keys:[,,'已确认'],
            info:{
                num1:100,
                num2:'2020-01',
                num3:1000,
                num4:'2020-02'
            },
            process:{
              processList:['HR1','HR2','HR3','HR4'],
              current:'HR2'
            },
            state:4   //1表示未提交，2表示当前已审批，3表示审批成功，4表示本人驳回，5表示其他人驳回
          },
            {
            title:'202001付款通知单',
            keys:[,,'已确认'],
            info:{
                num1:100,
                num2:'2020-01',
                num3:1000,
                num4:'2020-02'
            },
            process:{
              processList:['HR1','HR2','HR3','HR4'],
              current:'HR2'
            },
            state:5    //1表示未提交，2表示当前已审批，3表示审批成功，4表示本人驳回，5表示其他人驳回
          },
        ],
        filterList: [
          { text: "工资月份", type: 'select-timer',value:'0',value2:'',
            options:[{
                value: '0',
                label: '一周内'
              }, {
                value: '1',
                label: '一月内'
              },{
                value: 'qt',
                label: '其他'
              }
              ]
          },
          { text: "批次名称", type: 'text',value:''},
          { text: "薪酬组", type: 'select',value:'0',
            options: [{
                value: '0',
                label: '黄金糕'
              }, {
                value: '1',
                label: '双皮奶'
              }, {
                value: '2',
                label: '蚵仔煎'
              }, {
                value: '3',
                label: '龙须面'
              }, {
                value: '4',
                label: '北京烤鸭'
              }]
          },
          { text: "审批状态", type: 'radio',value:'',
            options:[{
                value: '0',
                label: '待审批'
              }, {
                value: '1',
                label: '已审批'
              }]
          },
          { text: "社保月份", type: 'timer',value:'' },
           { text: "计税类型", type: 'text',value:'' },
        ]
      };
    },
    created(){
      this.filterLists = JSON.parse(JSON.stringify(this.filterList))
    },
    methods: {
      details(){
        alert(111)
      },
    }
  };
</script>

<style scoped >
  .carBox{
    margin-top:10px;
    display: flex;
    flex-wrap: wrap;
  }
  .more span{
font-size:13px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(64,158,255,1);
line-height:18px;
cursor: pointer;
  }
  .more{
    text-align: right;
  }
  .more span:hover{
    text-decoration: underline;

  }


</style>
